import {create} from "@/api/rest";

const signIn = {
  signIn: async (data) => await create('/sign-in', data),
};

export default signIn;